import React, { useRef, useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { FaPhoneAlt } from "react-icons/fa";
import "../../assets/css/Navbar.css";

import emailjs from "@emailjs/browser";
import axios from "axios";
import { toast } from "react-toastify";

function Navbar() {
  const [searchQuery, setSearchQuery] = useState("");
  const navbarCollapseRef = useRef(null);
  const navbarRef = useRef(null);
  const navigate = useNavigate();
  const [toggelShow, setToggelShow] = useState(false);
  const [mobileSubOpen, setMobileSubOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showFormModel, setShowFormModel] = useState(false);

  // State for dynamic category selection
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [selectedSpecificCourse, setSelectedSpecificCourse] = useState("");
  const [selectedServiceCategory, setSelectedServiceCategory] = useState("");
  const [selectedSpecificService, setSelectedSpecificService] = useState("");
  
  // State for database submission
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [defaultBranchId, setDefaultBranchId] = useState(null);

  // Email Send
  const formRef = useRef();

  // Fetch Erode branch ID on component mount
  useEffect(() => {
    const fetchErodeBranch = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || "https://bs.aalantechsoft.com:8003/api";
        const response = await axios.get(`${apiUrl}/Branch`);
        const erodeBranch = response.data.find(branch => 
          branch.branch_name && branch.branch_name.toLowerCase().includes("erode")
        );
        if (erodeBranch) {
          setDefaultBranchId(erodeBranch._id);
          console.log("Default branch set to Erode:", erodeBranch.branch_name);
        } else if (response.data.length > 0) {
          setDefaultBranchId(response.data[0]._id);
        }
      } catch (error) {
        console.error("Error fetching branch:", error);
      }
    };
    
    fetchErodeBranch();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isSubmitting) return;

    // Get form data
    const formData = new FormData(formRef.current);
    const userName = formData.get('user_name');
    const mobileValue = formData.get('user_mobile');
    const emailValue = formData.get('user_email');
    const messageValue = formData.get('message') || '';

    // Validate inputs
    if (!userName || userName.trim().length < 2) {
      toast.error("Please enter a valid name (at least 2 characters)");
      return;
    }
    
    if (!mobileValue || !/^[0-9]{10}$/.test(mobileValue)) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }
    
    if (!emailValue || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailValue)) {
      toast.error("Please enter a valid email address");
      return;
    }

    setIsSubmitting(true);

    // Prepare data for email (always send both course and service info)
    let emailNeed = "";
    let enquiryType = "General";
    let courseCategory = "";
    let serviceCategory = "";
    
    if (selectedCategory === "Service") {
      emailNeed = `Service: ${selectedSpecificService || "Not specified"}`;
      enquiryType = "Service Enquiry";
      serviceCategory = selectedServiceCategory || "";
    } else if (selectedCategory === "Course") {
      emailNeed = `Course: ${selectedSpecificCourse || "Not specified"}`;
      enquiryType = "Course Enquiry";
      courseCategory = selectedCourseCategory || "";
    } else {
      emailNeed = "General Enquiry";
      enquiryType = "General Enquiry";
    }

    // Prepare data for database - Save ALL enquiries (Course, Service, General)
    let shouldSaveToDatabase = true; // Save all enquiries now
    let databaseNeed = "";
    
    if (selectedCategory === "Course" && selectedSpecificCourse) {
      databaseNeed = selectedSpecificCourse;
    } else if (selectedCategory === "Service" && selectedSpecificService) {
      databaseNeed = selectedSpecificService;
    } else {
      databaseNeed = "General Enquiry";
    }

    // Prepare lead data for backend
   // When sending the lead data, trim the course_category
const leadData = {
  student_name: userName.trim(),
  mobile_no: mobileValue,
  email: emailValue,
  Prefered_course: databaseNeed,
  message: messageValue,
  Source_type: "Website",
  enquiry_type: enquiryType,
  source_page: "Navbar Get A Quote",
  followups_status: "New",
  Enquiry_date: new Date().toISOString().split('T')[0],
  Enquiry_time: new Date().toLocaleTimeString(),
  branch_id: defaultBranchId,
  course_category: courseCategory.trim(), // ✅ TRIM HERE
  service_category: serviceCategory.trim(), // ✅ AND HERE
  service_need: emailNeed,
  user_agent: navigator.userAgent
};

    console.log("Saving enquiry to database:", leadData);
    
    // Save to database for ALL enquiries
    if (shouldSaveToDatabase) {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await axios.post(`${apiUrl}/leads`, leadData, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        
        console.log("✅ Database save successful:", response.data);
        
      } catch (error) {
        console.error("❌ Database save failed:", error);
        // Continue with email even if database save fails
      }
    }

    // Send email (always send for both course and service)
    try {
      const emailFormData = {
        user_name: userName,
        user_mobile: mobileValue,
        user_email: emailValue,
        user_need: emailNeed,
        message: messageValue
      };
      
      await emailjs.send(
        "service_1l6tarq",
        "template_pgbv6sl",
        emailFormData,
        "YVQ5H8UeZgOlMDTgO"
      );
      console.log("Email sent successfully");
      toast.success("Thank you! Our team will contact you soon.");
    } catch (error) {
      console.error("Email failed:", error);
      toast.success("Enquiry submitted successfully! Our team will contact you soon.");
    }
    
    // Show success message
    setShowFormModel(true);
    handleClose();
    
    // Reset selections after successful submission
    setSelectedCategory("");
    setSelectedCourseCategory("");
    setSelectedSpecificCourse("");
    setSelectedServiceCategory("");
    setSelectedSpecificService("");
    
    // Reset form
    if (formRef.current) {
      formRef.current.reset();
    }
    
    setIsSubmitting(false);
  };

  useEffect(() => {
    if (showFormModel) {
      const timer = setTimeout(() => {
        setShowFormModel(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showFormModel]);

  useEffect(() => {
    const handleScroll = () => {
      const sticky = window.scrollY > 0;
      setIsSticky(sticky);

      if (sticky && navbarRef.current) {
        document.body.style.paddingTop = navbarRef.current.offsetHeight + "px";
      } else {
        document.body.style.paddingTop = "0px";
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.body.style.paddingTop = "0px";
    };
  }, []);

  function toggleopenclose() {
    if (navbarCollapseRef.current) {
      if (toggelShow) {
        navbarCollapseRef.current.classList.remove("show");
      } else {
        navbarCollapseRef.current.classList.add("show");
      }
      setToggelShow(!toggelShow);
    }
  }

  const closeNavbar = () => {
    if (navbarCollapseRef.current.classList.contains("show")) {
      navbarCollapseRef.current.classList.remove("show");
    }
    setMobileSubOpen(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      if (searchQuery) {
        window.find(searchQuery);
      }
    }, 1000);
  };

  const [searchIcon, setSearchIcon] = useState(false);
  function handeleSearch() {
    setSearchIcon(!searchIcon);
  }
  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  const [triggerSearch, setTriggerSearch] = useState(false);
  useEffect(() => {
    if (triggerSearch) {
      eee();
      setTriggerSearch(false);
    }
  }, [triggerSearch]);

  const [searchResults, setSearchResults] = useState({});

  const searchAcrossRoutes = async () => {
    const routes = [
      "/about",
      "/mitsubishi",
      "/siemens",
      "/equipment-repair",
      "/contact",
      "/career",
      "/automotive-tyre",
      "/cement",
      "/machine-retrofit",
      "/",
    ];
    const results = {};
    for (const route of routes) {
      navigate(route);
      setLoading(true);
      await new Promise((r) => setTimeout(r, 1000));
      const found = window.find(searchQuery);
      if (found) {
        setTriggerSearch(true);
        results[route] = true;
        setLoading(false);
        break;
      } else {
        results[route] = false;
        setLoading(false);
      }
    }
    setSearchResults(results);
  };

  const handleKeyDown = async (e) => {
    if (e.key === "Enter") {
      if (!window.find(searchQuery)) {
        await searchAcrossRoutes();
        for (const [route, found] of Object.entries(searchResults)) {
          if (found) {
            navigate(route);
            setTriggerSearch(true);
            return;
          }
        }
      }
    }
  };

  const eee = () => {
    window.find(searchQuery);
  };

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    // Reset form selections when closing
    setSelectedCategory("");
    setSelectedCourseCategory("");
    setSelectedSpecificCourse("");
    setSelectedServiceCategory("");
    setSelectedSpecificService("");
    setIsSubmitting(false);
  };
  const handleShow = () => setShow(true);

  // Handle category change (Service / Course)
  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setSelectedCourseCategory("");
    setSelectedSpecificCourse("");
    setSelectedServiceCategory("");
    setSelectedSpecificService("");
  };

  // Handle course category change
  const handleCourseCategoryChange = (e) => {
    setSelectedCourseCategory(e.target.value);
    setSelectedSpecificCourse("");
  };

  // Handle service category change
  const handleServiceCategoryChange = (e) => {
    setSelectedServiceCategory(e.target.value);
    setSelectedSpecificService("");
  };

  // Handle specific course selection
  const handleSpecificCourseChange = (e) => {
    setSelectedSpecificCourse(e.target.value);
  };

  // Handle specific service selection
  const handleSpecificServiceChange = (e) => {
    setSelectedSpecificService(e.target.value);
  };

// Course categories data (updated without "Our")
const courseCategories = {
  "Industrial Automation": [
    "Master PLC Programming & Industrial Automation",
    "Certified PLC & SCADA Engineer",
    "Industrial Automation Engineer",
    "Industrial Automation Mastery",
  ],
  "Embedded Systems & IIoT ": [
    "Embedded Systems Kickstart",
    "Embedded Systems Engineer",
    "Embedded & IIoT Mastery",
  ],
  "Digital Marketing ": [
    "Digital Marketing Power-Up",
    "Advanced Digital Marketing Strategies",
    "Digital Marketing Mastery",
  ],
  "IT & Software Development ": [
    "Python Full Stack Development",
    "Java Full Stack Development",
    "MERN Stack Development",
    "Mobile App Development",
    "Data Analytics",
    "Data Science & Machine Learning",
    "UI/UX Design",
    "AWS Cloud",
    "DevOps Engineer",
    "Cybersecurity & Ethical Hacking",
  ],
};

// Service categories data (updated without "Our")
const serviceCategories = {
  "Industrial Automation ": [
    "Automation System Design & Engineering",
    "SCADA & Process Control Systems",
    "Robotic Solutions & PLC Programming",
    "Panel Fabrication & Control Systems",
    "Energy Management System (EMS)",
    "Training & Technical Support ",
  ],
  "Embedded Systems & IIoT ": [
    "Embedded Systems Design & Development",
    "IIoT Connectivity & Integration",
    "Smart Monitoring & Predictive Analytics",
    "Industrial Automation & Control Systems",
    "Wireless Sensor & Network Solutions",
    "Digital Twin & Energy Optimization",
  ],
  "Digital Marketing ": [
    "SEO & Content Marketing",
    "Social Media Marketing",
    "Paid Ads & PPC Campaigns",
    "Branding, Design & Video Production",
    "Website Design & Development",
    "Analytics, Email & Performance Reporting",
  ],
  "IT & Software ": [
    "Web & Mobile App Development",
    "AI, Data Science & Machine Learning",
    "Cloud Computing & DevOps",
    "Cybersecurity Solutions",
    "Custom Software & ERP Solutions",
    "Software Testing, QA & IT Support",
  ],
};

  return (
    <div>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/SH Logo.png")}
              alt="Loading"
            />
          </div>
        </div>
      )}

      {/* Topbar */}
      <div className="container-fluid bg-dark px-0">
        <div className="row g-0 d-none d-lg-flex">
          <div className="col-lg-6 ps-5 text-start">
            <div className="h-100 d-inline-flex align-items-center text-white">
              <a
                className="btn btn-link text-light"
                href="https://www.facebook.com/profile.php?id=61571592564080"
                aria-label="Facebook"
                target="blank"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/facebook_logo.png")}
                />
              </a>
              <a
                className="btn btn-link text-light"
                href="https://www.youtube.com/@Skimitarautomation"
                aria-label="Youtube"
                target="blank"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/youtube_logo.png")}
                />
              </a>
              <a
                className="btn btn-link text-light"
                href="https://linkedin.com/company/skimitar-hindusthan"
                aria-label="LinkedIn"
                target="blank"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/linkedin_logo.png")}
                />
              </a>
              <a
                className="btn btn-link text-light"
                href="https://www.instagram.com/skimitar_hindusthan_pvt_ltd/"
                aria-label="Instagram"
                target="blank"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/instagram_logo.png")}
                />
              </a>
              <a
                className="btn btn-link text-light"
                href="https://x.com/SkimitarAcademy"
                aria-label="X"
                target="blank"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/X-Logo-Twitter.png")}
                />
              </a>
              <a
                className="btn btn-link text-light"
                href="https://wa.me/91842801090"
                aria-label="Whatsapp"
                target="blank"
              >
                <img
                  className="logos_size"
                  alt=""
                  src={require("../../assets/img/whatsapp_logo.png")}
                />
              </a>
            </div>
          </div>
          <div className="col-lg-6 text-end">
            <div className="h-100 topbar-right d-inline-flex align-items-center text-white py-2 px-5">
              <span className="me-2">
                <FaPhoneAlt className="me-2" />
                Call Us:
              </span>
              <span>+91-842 801 0909</span>
            </div>
          </div>
        </div>
      </div>

      <nav
        ref={navbarRef}
        className={`navbar navbar-expand-lg nav-sticky-top ${isSticky ? "navbar-fixed " : ""}`}
      >
        <div className="row toggel_bottom">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-6 col-md-5 d-flex">
                <div>
                  <NavLink to="/" exact className="navbar-brand">
                    <img
                      src={require("../../assets/img/SH 07.png")}
                      alt="Logo"
                      className="text-white toggel_img"
                    />
                  </NavLink>
                </div>
                <div className="">
                  <button
                    onClick={toggleopenclose}
                    className="navbar-toggler toggel_button"
                    type="button"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon toggel_icon"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="collapse navbar-collapse"
          id="navbarCollapse"
          ref={navbarCollapseRef}
        >
          <div className="navbar-nav ms-auto p-4 p-lg-0">
            <NavLink
              to="/"
              id="new-dropdown-name"
              className="nav-item nav-link"
              activeClassName="active"
              onClick={closeNavbar}
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className="nav-item nav-link"
              activeClassName="active"
              onClick={closeNavbar}
            >
              About
            </NavLink>

            {/* ── SERVICE DROPDOWN ── */}
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Service
              </a>
              <div className="dropdown-menu dropDown_Menu m-0 p-3">
                <NavLink
                  to="/industrial-automation"
                  className="dropdown-item"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Industrial Automation
                </NavLink>
                <NavLink
                  to="/embadded-system"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Embedded System
                </NavLink>
                <NavLink
                  to="/digital-marketing"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Digital Marketing
                </NavLink>
                <NavLink
                  to="/it-software"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  IT &amp; Softwares
                </NavLink>
              </div>
            </div>
            {/* ── END SERVICE ── */}

            {/* Courses */}
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Courses
              </a>
              <div className="dropdown-menu dropDown_Menu bg-light m-0 p-3">
                <NavLink
                  to="/our-course"
                  className="dropdown-item"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Our Course
                </NavLink>
                <NavLink
                  to="/internship"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Internship
                </NavLink>
                <NavLink
                  to="/workshops"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Workshop
                </NavLink>
                <NavLink
                  to="/seminars"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Seminar
                </NavLink>
                <NavLink
                  to="/corporatetrainings"
                  className="dropdown-item mt-2"
                  activeClassName="active"
                  onClick={closeNavbar}
                >
                  Corporate Trainings
                </NavLink>
              </div>
            </div>

            <NavLink
              to="/career"
              className="nav-item nav-link"
              activeClassName="active"
              onClick={closeNavbar}
            >
              Career
            </NavLink>
            <NavLink
              to="/contact"
              className="nav-item nav-link"
              activeClassName="active"
              onClick={closeNavbar}
            >
              Contact
            </NavLink>
          </div>

          <div className="mobile-view">
            <button
              className="btn px-3 me-5 button-color"
              style={{ width: "147px" }}
              onClick={() => {
                handleShow();
                closeNavbar();
              }}
            >
              Get A Quote
            </button>
          </div>
        </div>
      </nav>

      {/* Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="custom-modal"
      >
        <Modal.Header closeButton className="custom-modal-header">
          <Modal.Title className="text-white">GET A QUOTE</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="text-secondary fs-6 text-center mb-3">
            Please fill out this form, and we will notify you. Our team will
            contact you shortly!
          </p>

          <Form ref={formRef} onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="user_name"
                placeholder="Name"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="tel"
                name="user_mobile"
                placeholder="Mobile (10 digits)"
                required
                maxLength={10}
                pattern="[0-9]{10}"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                name="user_email"
                placeholder="Email"
                required
              />
            </Form.Group>

            {/* Select your category dropdown */}
            <Form.Group className="mb-3">
              <Form.Select
                name="user_category"
                value={selectedCategory}
                onChange={handleCategoryChange}
                required
              >
                <option value="">Select your category</option>
                <option value="Service">Service</option>
                <option value="Course">Course</option>
              </Form.Select>
            </Form.Group>

            {/* Conditional rendering for COURSE selection */}
            {selectedCategory === "Course" && (
              <>
                <Form.Group className="mb-3">
                  <Form.Select
                    name="course_category"
                    value={selectedCourseCategory}
                    onChange={handleCourseCategoryChange}
                    required
                  >
                    <option value="">Select Course Category</option>
                    {Object.keys(courseCategories).map((category) => (
                      <option key={category} value={category}>
                        {category}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                {selectedCourseCategory && (
                  <Form.Group className="mb-3">
                    <Form.Select
                      name="specific_course"
                      value={selectedSpecificCourse}
                      onChange={handleSpecificCourseChange}
                      required
                    >
                      <option value="">Select Specific Course</option>
                      {courseCategories[selectedCourseCategory]?.map((course) => (
                        <option key={course} value={course}>
                          {course}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                )}
              </>
            )}

            {/* Conditional rendering for SERVICE selection */}
            {selectedCategory === "Service" && (
              <>
                <Form.Group className="mb-3">
                  <Form.Select
                    name="service_category"
                    value={selectedServiceCategory}
                    onChange={handleServiceCategoryChange}
                    required
                  >
                    <option value="">Select Service Category</option>
                    {Object.keys(serviceCategories).map((category) => (
                      <option key={category} value={category}>
                        {category}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                {selectedServiceCategory && (
                  <Form.Group className="mb-3">
                    <Form.Select
                      name="specific_service"
                      value={selectedSpecificService}
                      onChange={handleSpecificServiceChange}
                      required
                    >
                      <option value="">Select Specific Service</option>
                      {serviceCategories[selectedServiceCategory]?.map((service) => (
                        <option key={service} value={service}>
                          {service}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                )}
              </>
            )}

            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                name="message"
                placeholder="Message"
                rows={3}
                required
              />
            </Form.Group>

            <div className="text-center">
              <Button 
                className="btn text-white" 
                type="submit"
                disabled={isSubmitting}
                style={{ background: isSubmitting ? "#666" : "#cc0000", border: "none" }}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Success popup Model */}
      {showFormModel === true && (
        <>
          <Modal
            show={showFormModel}
            onHide={() => setShowFormModel(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Success</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
              <h5 className="text-red">Message Sent Successfully</h5>
              <p>Thank you for contacting us. We will get back to you soon.</p>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowFormModel(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </div>
  );
}

export default Navbar;